import GameCard from "@components/GameCard";
import Breaker from "@components/Breaker";
import { GlobalContext } from "App";
import { useContext } from "react";
import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
// import StripeGradient from "@components/StripeGradient";
import NewText from "@components/NewText";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;

type HomeScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _HomeScreen = (props: HomeScreenProps) => {
  const global = useContext(GlobalContext);

  return (
    <div className={props.className + " screen"}>
      {/* <StripeGradient _colors={["#5C5C5C", "#878787", "#727272"]} /> */}

      <NewText _text={"Coming Soon!"} _type={"title"} _align={"center"} />

      {/* <Breaker /> */}

      {/* <div
        style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
      >
        {global.get.GamesList.map((game, index) => {
          return <GameCard _game={game} key={index} />;
        })}
      </div> */}

      {/* <Breaker _size="3rem" /> */}
    </div>
  );
};

// ################################ STYLES ################################
const HomeScreen = styled(_HomeScreen).attrs((props): HomeScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default HomeScreen;
